/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.7.15",
    versionName: "0.2.0-nightly.2025.7.15",
    versionChannel: "nightly",
    buildDate: "2025-07-15T00:07:57.742Z",
    commitHash: "67b689ebf626f6ce91d22eb372e2edb90e1d0771",
};
